import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TwilioHelperService } from 'src/app/shared/services/twilio-helpers.service';
import { LocalizationService } from 'src/app/shared/localization/localization.service';


@Component({
  selector: 'app-confirm-logout',
  templateUrl: './confirm-logout.component.html',
  styleUrl: './confirm-logout.component.scss'
})
export class ConfirmLogoutComponent implements OnInit {

  constructor(public _dialogRef: MatDialogRef<ConfirmLogoutComponent>,
            public _localizationService: LocalizationService, 
            public _twilioService: TwilioHelperService
  ){

  }
  ngOnInit(): void {
  }
  onDialogCancel(): void {
    this._dialogRef.close();
  }
  confirmToLogout() {
    this._twilioService.logoutWorkerConfirm(true, true);
    this._dialogRef.close();
  }
}
